import type { GTM_ECommerce_TrackedEvents } from '@g4g/utils/src/gtm/gtm_ecommerce_event'
import { useEffect } from 'react'
import gtm_begin_checkout from './gtm_begin_checkout'
import gtm_view_cart from './gtm_view_cart'
import gtm_view_item from './gtm_view_item'

/**
 * Hook up inside the page component
 */
export default function useGtmVisit(event: GTM_ECommerce_TrackedEvents) {
  useEffect(() => {
    /**
     *
     * Should get called when <Linking to /page
     * or visiting /page manually.
     *
     * gtm not called on __DEV__, uncomment inside _app to
     * test.
     *
     * When testing this on __DEV__ it get's called twice
     * because of React v18 strict mode.
     * @see https://github.com/vercel/next.js/issues/35822
     * Do not panic though cause it should not affect prod builds.
     */
    switch (event) {
      case 'begin_checkout':
        gtm_begin_checkout()
        break
      case 'view_cart':
        gtm_view_cart()
        break
      case 'view_item':
        gtm_view_item()
        break
      default:
        break
    }
  }, [event])
}
